module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VGBACCARAT-6f1271866e77137428e479d72ab46aa9.png";